export default "__VITE_ASSET__9236c45b__"